import { render, staticRenderFns } from "./ProtocolRecommendation.vue?vue&type=template&id=3a12bfe1"
import script from "./ProtocolRecommendation.vue?vue&type=script&lang=js"
export * from "./ProtocolRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports